var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"export-data-options":_vm.exportDataOptions,"extraExportParams":_vm.ExtraListParams,"default-search-key":"topic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }